var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{on:{"click":_vm.resetState}},[_c('router-link',{attrs:{"to":_vm.service.url}},[_c('img',{attrs:{"src":_vm.service.img,"alt":_vm.service.title}}),_c('h2',[_vm._v(_vm._s(_vm.service.title))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }